module.exports = __webpack_public_path__ + "static/media/aboutChampange.f47e60cc.svg";